import { LEAD_DETAILS_OVERLAYS } from '~/features/leadDetails/constants/overlays';
import { useLeadDetailsOverlayState } from '~/features/leadDetails/hooks/useLeadDetailsOverlayState';

export const useOfferExtraInfoState = (offerId: string, routeControlled = false) =>
    useLeadDetailsOverlayState({
        isRouteControlled: routeControlled,
        key: LEAD_DETAILS_OVERLAYS.OFFER_EXTRA_INFO_ID,
        value: offerId,
    });
